import { render, staticRenderFns } from "./SponsoredLinks.vue?vue&type=template&id=0b78837a"
import script from "./SponsoredLinks.vue?vue&type=script&lang=ts"
export * from "./SponsoredLinks.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports